import { useDispatch, useSelector } from 'react-redux';
import { selectTypeOfBillingReport, setSelectedBillingReportTypes, setSelectedClientIdBillingReport, setSelectedDeceaseName, toggleBillingReportType } from '../../../features/reports/reportsSlice';
import { billingReportTypes } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import { clearTypeOfAdditionalModal } from '../../../features/modal/modalSlice';
import useReport from '../../../hooks/actions/useReport';

export default function ExportBillingTypeModal() {

    const dispatch = useDispatch()
    const selectedTypes = useSelector(selectTypeOfBillingReport);
    const { generateBillingReport, isLoadingExportBillingReport } = useReport()

    const onClose = () => {
        dispatch(clearTypeOfAdditionalModal())
        dispatch(setSelectedClientIdBillingReport(null))
        dispatch(setSelectedDeceaseName(null))
        dispatch(setSelectedBillingReportTypes(['detailed', 'summary']))
    }

    const handleToggle = (type: "summary" | "detailed") => {
        dispatch(toggleBillingReportType(type))
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
            <div className="relative bg-white rounded shadow w-11/12 sm:w-96 md:w-[500px] p-6">
                <div className="space-y-7">
                    <div>
                        <h2 className="text-base font-medium text-gray-900">{'Export Billing'}</h2>
                        <p className="text-sm text-gray-600">{'You can export the summary report, the detailed report, or both.'}</p>
                    </div>
                    <div className="space-y-3">
                        {billingReportTypes.map(({ value, title, description }) => {
                            const isSelected = selectedTypes.includes(value);
                            return (
                                <label
                                    key={value}
                                    className={`${isLoadingExportBillingReport ? 'cursor-not-allowed' : 'cursor-pointer'} flex items-center gap-3 rounded border px-3 py-1.5 transition-colors ${
                                        isSelected
                                            ? "border-cbColor bg-cbColor/5"
                                            : "border-gray-300 hover:border-cbColor"
                                    }`}
                                >
                                    <input
                                        type="checkbox"
                                        disabled={isLoadingExportBillingReport}
                                        checked={isSelected}
                                        onChange={() => handleToggle(value)}
                                        className="h-3 w-3 accent-cbColor disabled:cursor-not-allowed"
                                    />
                                    <div>
                                        <p className="text-sm font-medium">{title}</p>
                                        <p className="text-xs text-gray-500">{description}</p>
                                    </div>
                                </label>
                            );
                        })}
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <button onClick={onClose} disabled={isLoadingExportBillingReport} className="disabled:cursor-not-allowed w-full py-1.5 rounded text-sm font-medium bg-gray-300 text-black">
                            Close
                        </button>
                        <button onClick={generateBillingReport} disabled={isLoadingExportBillingReport || selectedTypes.length === 0} className="w-full py-1.5 rounded text-sm font-medium bg-cbColor text-white disabled:cursor-not-allowed">
                            {isLoadingExportBillingReport ? (
                                <div className="flex items-center w-full justify-center">
                                    <Loading setH={'h-[20px]'} setBgColor="" spinColor='#fffff'/>
                                    Exporting...
                                </div>
                            ) : (
                                'Export'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
